import styled from "styled-components";

export const Body = styled.div`

    min-height: 100vh;
    width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    background-color: #EAE8E3;
    background-image:
        repeating-linear-gradient(0deg, rgba(0, 0, 0, 0.05) 0 1px, transparent 1px 40px),
        repeating-linear-gradient(90deg, rgba(0, 0, 0, 0.05) 0 1px, transparent 1px 40px);
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    color: #171717;
`

export const BotaoLeft = styled.div`
    margin-top: 3vh;
    margin-left: 3vh;
    border: none;
    .left{ width: 5vw }

    img{
        border-radius: 50%;
        transition: transform 0.15s ease, box-shadow 0.15s ease;

        :hover{
            transform: scale(1.08);
            box-shadow: 0 0 0 4px rgba(240, 82, 79, 0.25);
            }
    }

    @media screen and (max-width: 760px) {
        display: none;
    }
`

export const TopoSeta = styled.div`

    display: flex ;
    flex-shrink: 0 ;
    margin-bottom: 1vh ;
`

export const DivDigital = styled.div`

    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 2vh 3vw;
    box-sizing: border-box;

    gap: 1.5vw;

    .CalcDigital {

        width: 40vw;
        max-width: 600px;
        background-color: #fff;
        border: 2px solid #d5d5d5;
        border-radius: 1vw;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        padding: 1.1vw 2.4vw 1.3vw;
        box-sizing: border-box;

            .topo {
                text-align: center;
                margin-bottom: 0.5vw;
                font-size: 1.4vw;
                font-weight: 800;
                color: #171717;
                line-height: 1.2;
            }

            hr { border: none; border-top: 2px solid #F5A623; margin: 0 0 0.6vw; };

            .titulo { margin-bottom: 0.5vw; text-align: left; }

            .titulo-linha {
                display: flex;
                flex-direction: row;
                align-items: flex-end;
                gap: 0.8vw;
                margin-bottom: 0.5vw;

                .coluna-campos {
                    flex: 1;
                    min-width: 0;
                    display: flex;
                    flex-direction: column;

                    .titulo:first-child { margin-bottom: 0.5vw; }
                    .titulo:last-child {
                        margin-bottom: 0;
                        input { width: 8vw; }
                    }
                }
            }

            .titulo.checkbox-linha {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 1.5vw;

                label {
                    display: flex;
                    align-items: center;
                    gap: 0.5vw;
                    font-size: 0.9vw;
                    font-weight: 700;
                    color: #171717;
                    cursor: pointer;
                }

                input[type="checkbox"] {
                    width: 1vw;
                    height: 1vw;
                    accent-color: #F0524F;
                    cursor: pointer;
                }
            }

            .subtitulo {
                font-size: 0.95vw;
                font-weight: 700;
                color: #171717;
                margin-bottom: 0.15vw;
            }

            .seta-medida {
                color: #F0524F;
                font-weight: 900;
                font-size: 1.1vw;
            }

            .alerta {
                    font-size: 0.68vw;
                    color: #8a8a8a;
                    font-weight: 500;
                    margin-bottom: 0.2vw;
            }

            .alerta.vermelho {
                    color: #b23b38;
                    font-weight: 700;
            }

            select, input {
                box-sizing: border-box;
                font-family: Verdana, Geneva, Tahoma, sans-serif;
                font-size: 0.95vw;
                padding: 0.35vw 0.7vw;
                border: 2px solid #e2e2e2;
                border-radius: 0.5vw;
                color: #171717;
                outline: none;
                transition: border-color 0.15s ease;

                :focus { border-color: #F0524F; }
                }

            select { width: 100%; }
            input { width: 17.2vw; }

            button {
                display: block;
                width: 100%;
                margin-top: 0.4vw;
                background-color: #F0524F;
                color: #fff;
                font-weight: 700;
                font-size: 1.0vw;
                padding: 0.5vw;
                border: none;
                border-radius: 2vw;
                cursor: pointer;
                transition: background-color 0.2s ease;

                :hover{
                    background-color: #d63d3a;
                    }
            }

            .resultado{
                margin-top: 0.6vw;
                padding: 0.55vw;
                border-radius: 0.6vw;
                text-align: center;
                font-size: 1.0vw;
                font-weight: 700;
            }

            .resultado.sucesso {
                background: #e9f7ef;
                color: #1c7c3f;
                border: 2px solid #bfe8cd;
            }

            .resultado.pendente {
                background: transparent;
                color: #b23b38;
                font-weight: 600;
                font-size: 0.8vw;
                padding: 0.2vw 0;
            }

            .sugestao-inversao {
                flex: 1;
                min-width: 0;
                padding: 0.4vw 0.6vw;
                border-radius: 0.5vw;
                background: #fff8e1;
                border: 2px solid #F5A623;
                color: #7a5c00;
                font-size: 0.68vw;
                font-weight: 600;
                line-height: 1.35;
                text-align: center;
            }

            .envio {
                margin-top: 0.7vw;
                padding-top: 0.6vw;
                border-top: 2px dashed #e2e2e2;

                .subtitulo { margin-bottom: 0.3vw; }

                .campo-email {
                    display: flex;
                    gap: 0.5vw;

                    input { flex: 1; }

                    button {
                        width: auto;
                        margin-top: 0;
                        padding: 0 1.2vw;
                        white-space: nowrap;
                    }
                }

                .envio-status {
                    margin-top: 0.3vw;
                    font-size: 0.78vw;
                    color: #1c7c3f;
                    font-weight: 600;
                }
            }
    }

    .Disposicao {

        width: 20vw;
        max-width: 330px;
        background-color: #fff;
        border: 2px solid #d5d5d5;
        border-radius: 1vw;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        padding: 1.1vw 1.4vw 1.3vw;
        box-sizing: border-box;
        text-align: center;

        .topo {
            margin-bottom: 0.5vw;
            font-size: 1.0vw;
            font-weight: 800;
            color: #171717;
            line-height: 1.2;
        }

        hr { border: none; border-top: 2px solid #F5A623; margin: 0 0 0.6vw; }

        .subtitulo.centro {
            font-size: 0.85vw;
            font-weight: 700;
            color: #171717;
            margin-bottom: 0.6vw;
        }

        .desenho {
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            gap: 0.3vw;
            min-height: 8vw;
            width: 100%;
        }

        .etiqueta-desenho {
            display: block;
            position: relative;
            flex-shrink: 0;
            box-sizing: border-box;
            background: rgba(240, 82, 79, 0.15);
            border: 1px solid #F0524F;
            border-radius: 2px;
        }

        .etiqueta-desenho .seta-medida {
            color: #F0524F;
            font-weight: 900;
            font-size: 0.99vw;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            white-space: nowrap;
        }

        .legenda {
            margin-top: 0.6vw;
            font-size: 0.72vw;
            color: #8a8a8a;
            font-weight: 500;
        }

        .resultado.pendente {
            font-size: 0.75vw;
            color: #b23b38;
            font-weight: 600;
        }
    }

    @media screen and (max-width: 760px) {

        flex-direction: column;
        padding: 1vh 5vw 6vh;

        .CalcDigital {
            width: 100%;
            max-width: none;
            border-radius: 3vw;
            padding: 6vw 6vw 8vw;

                .topo {
                font-size: 6vw ;
                margin-bottom: 4vw ;
                }

                hr{ margin-bottom: 4vw }

                .titulo { margin-bottom: 4vw; }

                .titulo-linha {
                    flex-direction: column;
                    align-items: stretch;
                    gap: 4vw;

                    .coluna-campos {
                        .titulo:first-child { margin-bottom: 4vw; }
                        .titulo:last-child input { width: 100%; }
                    }
                }

                .sugestao-inversao {
                    font-size: 3.2vw;
                    padding: 2.5vw 3vw;
                    border-radius: 2vw;
                }

                .titulo.checkbox-linha {
                    flex-wrap: wrap;
                    row-gap: 3vw;

                    label {
                        font-size: 3.8vw;
                        gap: 2vw;
                    }

                    input[type="checkbox"] {
                        width: 4.5vw;
                        height: 4.5vw;
                    }
                }

                .subtitulo{
                    font-size: 4vw;
                }

                .envio .subtitulo {
                    font-size: 3.2vw;
                }

                .alerta{
                    font-size: 3vw;
                    margin-bottom: 1.5vw;
                }

                select, input {
                    width: 100%;
                    font-size: 4vw;
                    padding: 2.5vw 3vw;
                    border-radius: 2vw;
                }

                .botao-auto {
                    display: none;
                }

                button {
                    font-size: 4.5vw;
                    padding: 3vw;
                    border-radius: 8vw;
                }

                .resultado{
                    font-size: 4vw;
                    padding: 3vw;
                }

                .resultado.pendente {
                    font-size: 3.4vw;
                }

                .envio {
                    .campo-email { flex-direction: column; }
                    .envio-status { font-size: 3.2vw; }
                }
        }

        .Disposicao {
            width: 100%;
            max-width: none;
            margin-top: 4vw;
            border-radius: 3vw;
            padding: 5vw;

            .topo { font-size: 4.5vw; margin-bottom: 3vw; }
            hr { margin-bottom: 3vw; }
            .subtitulo.centro { font-size: 4vw; margin-bottom: 3vw; }
            .desenho { min-height: 20vw; }
            .legenda { font-size: 3.2vw; margin-top: 3vw; }
            .resultado.pendente { font-size: 3.4vw; }
        }
    }

`;
